import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/images/admin-img/upload-document-icon.svg'
import _imports_1 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_14 = { class: "tags" }
const _hoisted_15 = { class: "delete-all-btn-link" }
const _hoisted_16 = { class: "add-banner-image-section" }
const _hoisted_17 = { class: "add-banner-image-box" }
const _hoisted_18 = { class: "admin-input-field" }
const _hoisted_19 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_20 = { class: "admin-input-field" }
const _hoisted_21 = { class: "image-upload-input upload-banner-image" }
const _hoisted_22 = { class: "image-upload-input-item" }
const _hoisted_23 = { class: "file-input-box" }
const _hoisted_24 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_25 = {
  key: 1,
  class: "browsed-img"
}
const _hoisted_26 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_27 = { class: "admin-input-field-submit" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "admin-item-list-section upload-documents-section" }
const _hoisted_30 = { class: "admin-item-list-section-in" }
const _hoisted_31 = { class: "admin-item-list-section-scroll" }
const _hoisted_32 = { class: "admin-item-list-top" }
const _hoisted_33 = { class: "admin-item-list-row" }
const _hoisted_34 = { class: "admin-item-checkbox" }
const _hoisted_35 = { class: "admin-checkbox-input" }
const _hoisted_36 = ["checked"]
const _hoisted_37 = { class: "admin-item-title" }
const _hoisted_38 = { class: "admin-item-actions-3" }
const _hoisted_39 = { class: "admin-item-list-btm" }
const _hoisted_40 = { class: "admin-item-box-top" }
const _hoisted_41 = { class: "admin-item-list-row" }
const _hoisted_42 = { class: "admin-item-checkbox" }
const _hoisted_43 = { class: "admin-checkbox-input" }
const _hoisted_44 = ["id", "onChange", "checked"]
const _hoisted_45 = ["for"]
const _hoisted_46 = { class: "admin-item-title text-limit" }
const _hoisted_47 = { class: "admin-item-actions-3" }
const _hoisted_48 = { class: "admin-action-link" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "admin-pagination-section" }
const _hoisted_54 = { class: "custom-row" }
const _hoisted_55 = { class: "item-show-selectbox" }
const _hoisted_56 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "admin-site-footer" }
const _hoisted_59 = { class: "container" }
const _hoisted_60 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_61 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "confirmation-popup-mid" }
const _hoisted_64 = { class: "confirmation-popup-btm" }
const _hoisted_65 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_UPLOAD_DOCUMENTS_FOR_CHAT_BOT_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "publishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'published' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('published')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.published), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "unPublishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'unpublished' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('unpublished')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.UNPUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.unpublished), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        id: "addBannerBtn",
                        class: "admin-btn-primary primary-icon-btn",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddDocumentForm = true))
                      }, [
                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_NEW_DOCUMENT_BUTTON), 1)
                      ])
                    ])
                  ]),
                  (_ctx.selectedDocuments.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedDocuments.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (
                              (_ctx.selectedDocuments = []), (_ctx.selectAll = false)
                            ))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["white-bg-border add-new-section", { 'show-section': _ctx.showAddDocumentForm }])
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_DOCUMENT_TEXT), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("form", {
                    id: "addBannerImageForm",
                    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "bnrPgTitleInput",
                        type: "text",
                        placeholder: "Enter the Title",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newDocument.title) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newDocument.title]
                      ]),
                      (!_ctx.newDocument.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errors.titleErrMsg), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.UPLOAD_DOCUMENT_LABEL), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "image-upload-input-item-delete-btn",
                            id: "uploaded-img-delete-btn",
                            type: "button",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearUploadedFile()))
                          }),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("input", {
                              id: "bnrPgFileInput",
                              type: "file",
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleFileUpload($event)))
                            }, null, 32)
                          ]),
                          (!_ctx.fileUploaded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                  _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: ""
                                  })
                                ], -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_DOCUMENT_LABEL), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.fileUploaded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.fileName), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (!_ctx.selectedFile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.errors.fileErrMsg), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("button", {
                        id: "bnrPgSubmitBtn",
                        class: "admin-btn-outline-primary",
                        disabled: _ctx.isSubmitting
                      }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_28),
                      _createElementVNode("button", {
                        id: "bnrPgCancelBtn",
                        class: "admin-btn-outline-secondary",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                      }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                    ])
                  ], 32)
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("input", {
                            name: "cssCheckbox",
                            id: "allCheckInput",
                            type: "checkbox",
                            class: "css-checkbox",
                            onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                            checked: _ctx.selectAll === true
                          }, null, 40, _hoisted_36),
                          _cache[19] || (_cache[19] = _createElementVNode("label", { for: "allCheckInput" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    (_ctx.documents.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.documents, (document) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "admin-item-box",
                            key: document.id
                          }, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("input", {
                                      name: "cssCheckbox",
                                      id: 'checkItemOneInput' + document.id,
                                      type: "checkbox",
                                      class: "css-checkbox",
                                      onChange: ($event: any) => (_ctx.toggleDocumentSelection(document.id)),
                                      checked: 
                                  _ctx.selectedDocuments.includes(document.id)
                                
                                    }, null, 40, _hoisted_44),
                                    _createElementVNode("label", {
                                      for: 'checkItemOneInput' + document.id
                                    }, null, 8, _hoisted_45)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_46, _toDisplayString(document.title), 1),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("ul", _hoisted_48, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        id: "bnrPgDeleteBtn",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#deletePop",
                                        onClick: ($event: any) => (
                                    _ctx.setDeleteMode('single', document.id),
                                      (_ctx.showAddDocumentForm = false)
                                  )
                                      }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_49)
                                    ]),
                                    _createElementVNode("li", null, [
                                      (document.status === 1)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            id: "bnrPgPublishBtn",
                                            onClick: ($event: any) => (_ctx.changeDocumentStatus(document.id, 0))
                                          }, _toDisplayString(_ctx.constants.UNPUBLISH_BUTTON), 9, _hoisted_50))
                                        : (document.status === 0)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 1,
                                              id: "bnrPgPublishBtn",
                                              onClick: ($event: any) => (_ctx.changeDocumentStatus(document.id, 1))
                                            }, _toDisplayString(_ctx.constants.PUBLISH_BUTTON), 9, _hoisted_51))
                                          : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_52, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("p", null, "No data to display", -1)
                        ]))]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _withDirectives(_createElementVNode("select", {
                      id: "paginationSelectBox",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.limit) = $event)),
                      onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                    }, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("option", { value: "10" }, "10", -1),
                      _createElementVNode("option", { value: "20" }, "20", -1),
                      _createElementVNode("option", { value: "50" }, "50", -1),
                      _createElementVNode("option", { value: "100" }, "100", -1)
                    ]))], 544), [
                      [_vModelSelect, _ctx.limit]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                  ]),
                  (_ctx.totalPages > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("ul", null, [
                          (_ctx.currentPage !== 1)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                              }, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "pagination-previous"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (_ctx.totalPages != 1)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: page,
                                  onClick: ($event: any) => (_ctx.changePage(page))
                                }, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: _normalizeClass({ active: _ctx.currentPage === page })
                                  }, _toDisplayString(page), 3)
                                ], 8, _hoisted_57))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.currentPage !== _ctx.totalPages)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 2,
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                              }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "pagination-next"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("button", _hoisted_65, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}